import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateCategory = () => {
  const token = useAuthToken();

  const createCategory = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/category", credentials, token);
  };

  return createCategory;
};

export const useGetCategory = () => {
  const token = useAuthToken();

  const getCategory = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    return apiRequest("get", "/api/category", null, token);
  };

  return getCategory;
};

export const useGetCategoryById = (id) => {
  const token = useAuthToken();

  // Function to fetch category data
  const getCategoryById = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    const response = await apiRequest(
      "get",
      `/api/category/${id}`,
      null,
      token
    );

    return response;
  };
  return useQuery({
    queryKey: ["single-category", id],
    queryFn: getCategoryById,
    enabled: !!id,
  });
};

export const useUpdateCategory = (id) => {
  const token = useAuthToken();

  const updateCategory = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/category/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateCategory;
};
